export const listResults = (resources: any) => resources?.results ?? [];

export const asOpportunity = (row: any) => ({
  id: row?.id ?? row?.reference_number ?? 'N/A',
  title: row?.title ?? row?.program_name ?? row?.name ?? `Opportunity ${row?.id ?? ''}`,
  status: row?.status ?? (row?.active_solicitation ? 'open' : 'anticipated'),
  fit: row?.fit ?? row?.fit_score ?? row?.confidence_score ?? 0,
  program_category: row?.program_category?.name ?? row?.program_category ?? 'Innovation procurement',
  submission_window: row?.submission_window ?? row?.deadline ?? 'Open',
  eligibility: row?.eligibility ?? 'Canadian dual-use and prime applicants',
  requirements: row?.requirements ?? []
});

export const asSubmission = (row: any) => ({
  id: row?.id ?? row?.reference_number ?? `SUB-${row?.id ?? ''}`,
  name: row?.name ?? row?.company_name ?? row?.title ?? `Submission ${row?.id ?? ''}`,
  submission: row?.submission ?? row?.product_description ?? row?.company_name ?? row?.name ?? `Submission ${row?.id ?? ''}`,
  company: row?.company ?? row?.company_name ?? row?.company_profile?.company_name ?? 'Company',
  translated_capability: row?.translated_capability ?? row?.capability_statement ?? row?.mapped_capability ?? row?.product_description ?? 'Awaiting translated capability',
  confidence_weighting: row?.confidence_weighting ?? row?.confidence_score ?? row?.confidence ?? 'Draft',
  suggested_mechanism: row?.suggested_mechanism ?? row?.recommended_mechanism ?? row?.route ?? 'Navigator review',
  weak_signal_flag: row?.weak_signal_flag ?? row?.weak_signal ?? row?.weakSignal ?? 'Unknown',
  status: row?.status ?? 'Draft',
  confidence: row?.confidence ?? row?.confidence_score ?? 'Draft',
  score: Number(row?.score ?? row?.confidence_score ?? row?.confidence ?? 0) || 0,
  navigator: row?.navigator ?? row?.navigator_name ?? 'Navigator pending',
  updated: row?.updated ?? row?.updated_at ?? '',
  sector: row?.sector ?? row?.primary_sector ?? row?.mapped_capability ?? 'Dual-use',
  endUser: row?.endUser ?? row?.likely_end_user ?? row?.end_user?.name ?? 'Not assigned',
  weakSignal: row?.weakSignal ?? row?.weak_signal ?? 'Unknown',
  capability: row?.capability ?? row?.mapped_capability ?? row?.product_description ?? 'Capability pending',
  route: row?.route ?? row?.recommended_mechanism ?? 'Dual-use'
});

export const asKnowledgeRecord = (row: any) => ({
  title: row?.title ?? row?.program_name ?? row?.source_name ?? `Resource ${row?.id ?? ''}`,
  description: row?.description ?? row?.notes ?? row?.eligibility ?? 'Knowledge base resource',
  href: row?.href ?? row?.source_url ?? '/resources/guides',
  q: row?.q ?? row?.program_name ?? row?.topic ?? 'Knowledge base question',
  a: row?.a ?? row?.notes ?? row?.eligibility ?? row?.funding ?? 'Refer to the linked source for details.'
});

export const asPartner = (row: any) => ({
  name: row?.name ?? row?.company_name ?? `Partner ${row?.id ?? ''}`,
  focus: row?.focus ?? row?.focus_areas ?? row?.primary_sector ?? 'Capability growth',
  type: row?.type ?? row?.partner_type ?? 'Partner'
});

export const asHandoff = (row: any) => ({
  id: row?.id ?? `${row?.date}-${row?.action}`,
  date: row?.date ?? row?.created_at ?? '',
  from: row?.from ?? row?.from_party ?? 'Navigator',
  to: row?.to ?? row?.to_party ?? 'DIA Coordination',
  action: row?.action ?? 'File update',
  outcome: row?.outcome ?? row?.status ?? row?.notes ?? 'Updated',
  company: row?.company ?? row?.submission?.company_name ?? 'Company',
  capability: row?.capability ?? row?.submission?.mapped_capability ?? 'Capability pending',
  route: row?.route ?? row?.routing_recommendation?.recommended_mechanism ?? 'Dual-use',
  status: row?.status ?? row?.outcome ?? 'In Progress',
  next_action: row?.next_action ?? row?.action ?? 'Review next step',
  updated: row?.updated ?? row?.updated_at ?? ''
});
